// extracted by mini-css-extract-plugin
export default {"emote":"_7BrM6","not-official":"_1YZbL","notOfficial":"_1YZbL","title":"_10Rot","emote-pixel":"_2fPpN","emotePixel":"_2fPpN"};